export enum ConfiguratorMode {
	PART = 'PART',
	ITEM = 'ITEM',
	// The lines of a cutting list of the part take the place of the scene
	CUTTING_LIST = 'CUTTING_LIST',
	PREVIEW = 'PREVIEW'
}

export enum SelectionMode {
	ARTICLE = "ARTICLE",
	FRONT = "FRONT"
}

export enum ArticleZoneBoundary {
	MOVABLE = "MOVABLE",
	FIXED = "FIXED"
}

export enum ConfiguratorView {
	PART_ITEM = 'PART_ITEM',
	CUTTING_LIST = 'CUTTING_LIST',
	HARDWARE = 'HARDWARE',
	CATALOG = 'CATALOG',
	MATERIAL = 'MATERIAL',
	QUOTATION = 'QUOTATION',
}
